import React from 'react';
import { Box, TextField, Stack, Alert } from '@mui/material';

const DemoComposer = ({ form, onChange, disabled }) => {
  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 1 }}>
        <TextField
          size="small"
          label="Video link"
          fullWidth
          value={form.video || ''}
          onChange={(e) => onChange({ ...form, video: e.target.value })}
          disabled={disabled}
        />
        <TextField
          size="small"
          label="Screenshots (URLs, comma separated)"
          fullWidth
          value={form.screenshots || ''}
          onChange={(e) => onChange({ ...form, screenshots: e.target.value })}
          disabled={disabled}
        />
      </Stack>
      <TextField
        fullWidth
        multiline
        minRows={2}
        label="Additional info"
        value={form.info || ''}
        onChange={(e) => onChange({ ...form, info: e.target.value })}
        disabled={disabled}
      />
      <Alert severity="info" sx={{ mt: 1 }}>
        Demo posts are not implemented yet. This is a stub UI.
      </Alert>
    </Box>
  );
};

export default DemoComposer;
